import { Button, InputNumber } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Dispatch, SetStateAction } from 'react';

const QuantitySelector = ({ value, onChange }: { value: number | null; onChange: Dispatch<SetStateAction<number | null>> }) => (
  <InputNumber
    name="quantity"
    value={value}
    onChange={onChange}
    className='ch-product-details-item-quantity'
    addonBefore={
      <Button
        type='text'
        icon={<PlusOutlined />}
        onClick={() => onChange(value !== null ? value + 1 : 1)}
      />
    }
    addonAfter={
      <Button
        type='text'
        icon={<MinusOutlined />}
        onClick={() => onChange(value !== null && value > 1 ? value - 1 : 1)}
      />
    }
    defaultValue={1}
    min={1}
  />
);

export default QuantitySelector;
